// Helper to resolve org unit form field settings, fetching if necessary.
// Returns formatted field settings object or null on failure.
import { fetchOrgUnitFormFields } from "app/main/orgUnits/actions/orgUnit.actions";
import { areCurrentOrgUnitFormFieldsLoaded, getCurrentOrgUnitFormFields } from "app/main/orgUnits/reducers/orgUnit.reducers";

export const resolveFieldSettings = async (dispatch, getState, orgUnitId, formType = "CreateEditTreatment") => {
  try {
    const state = getState();
    if (areCurrentOrgUnitFormFieldsLoaded(state, orgUnitId, formType)) {
      return getCurrentOrgUnitFormFields(state, orgUnitId, formType);
    }
    await dispatch(fetchOrgUnitFormFields(orgUnitId, formType));
    const postState = getState();
    return getCurrentOrgUnitFormFields(postState, orgUnitId, formType);
  } catch (e) {
    return null;
  }
};

export default resolveFieldSettings;
